module.exports = __webpack_public_path__ + "media/images/tmp/slide0-9a415272d2b48e06d68cb99ed7205857.jpg";